import { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../../api_config";
import { FaCheckCircle, FaSpinner, FaTimesCircle } from "react-icons/fa";
import UserContext from "../../Authcontext";
import "./PaymentSuccess.css";

function PaymentSuccess() {
  const [status, setStatus] = useState("checking");
  const [message, setMessage] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const { token, isAuthenticated } = useContext(UserContext);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const checkPaymentStatus = async () => {
      const urlParams = new URLSearchParams(location.search);
      const txId = urlParams.get('transactionId') || urlParams.get('merchantOrderId');
      
      console.log("Payment callback received:", { 
        params: Object.fromEntries(urlParams),
        transactionId: txId 
      });

      if (!txId) {
        setStatus("error");
        setMessage("No transaction ID found in callback");
        return;
      }

      setTransactionId(txId);

      try {
        if (!isAuthenticated || !token) {
          setStatus("error");
          setMessage("Authentication required. Please login to check payment status.");
          return;
        }

        const response = await axios.get(
          `${API_BASE_URL}/api/payment-status?transactionId=${txId}`,
          {
            headers: { 
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          }
        );

        console.log("Payment status response:", response.data);

        if (response.data.status === 'SUCCESS' || response.data.success) {
          setStatus("success");
          setMessage("Payment completed successfully! Your premium membership has been activated.");
          
          // Refresh user data after 2 seconds
          setTimeout(() => {
            window.location.href = "/";
          }, 3000);
        } else {
          setStatus("error");
          setMessage(response.data.message || "Payment failed or is still processing.");
        }
      } catch (error) {
        console.error("Payment status check error:", error);
        setStatus("error");
        setMessage("Error verifying payment status. Please check your dashboard.");
      }
    };

    checkPaymentStatus();
  }, [location]);

  return (
    <div className="payment-status-container">
      <div className="payment-status-card">
        {status === "checking" && (
          <div className="status-checking">
            <FaSpinner className="spinning-icon" />
            <h2>Verifying Payment...</h2>
            <p>Please wait while we confirm your payment status.</p>
            <div className="transaction-id">
              Transaction ID: {transactionId}
            </div>
          </div>
        )}
        
        {status === "success" && (
          <div className="status-success">
            <FaCheckCircle className="success-icon" />
            <h2>Payment Successful! 🎉</h2>
            <p>{message}</p>
            <div className="transaction-id">
              Transaction ID: {transactionId}
            </div>
            <p className="redirect-message">Redirecting to homepage...</p>
            <button 
              onClick={() => navigate("/")} 
              className="dashboard-btn"
            >
              Go to Dashboard Now
            </button>
          </div>
        )}
        
        {status === "error" && (
          <div className="status-error">
            <FaTimesCircle className="error-icon" />
            <h2>Payment Issue</h2>
            <p>{message}</p>
            <div className="transaction-id">
              Transaction ID: {transactionId}
            </div>
            <div className="error-actions">
              <button 
                onClick={() => navigate("/payment/paymentoption")} 
                className="retry-btn"
              >
                Try Payment Again
              </button>
              <button 
                onClick={() => navigate("/")} 
                className="home-btn"
              >
                Go to Homepage
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default PaymentSuccess;